<template>
    <Card class="app-page-header-card px-2 border-radius-0" :bodyStyle="bodyStyle">
        <div class="d-flex">
            <div class="my-auto">
                <CIcon file="back.svg" class="text-secondary px-1 text-24" @click="onClickBack" v-if="canBackComputed"></CIcon>
            </div>
            <div class="my-auto w-100">
                <Row type="flex" v-if="routes.length > 0 || stateAppLayout.appPageHeader.slots.top">
                    <Col v-if="!stateAppLayout.appPageHeader.isHiddenBreadcrumb">
                        <Breadcrumb class="mx-1 mb-1">
                            <template v-for="(route, index) in routes" :key="index">
                                <BreadcrumbItem >
                                    <template v-if="route.url && index + 1 !== routes.length">
                                        <router-link v-if="stateAppLayout.isLayout" :to="route.url">{{ route.name }}</router-link>
                                        <span v-else>{{ route.name }}</span>
                                    </template>
                                    <template v-else>
                                        <span class="text-18">{{ route.name }}</span>
                                    </template>
                                </BreadcrumbItem>
                            </template>
                        </Breadcrumb>
                    </Col>
                    <component v-if="stateAppLayout.appPageHeader.slots.top" :is="stateAppLayout.appPageHeader.slots.top"></component>
                </Row>
                <component v-if="stateAppLayout.appPageHeader.slots.default" :is="stateAppLayout.appPageHeader.slots.default"></component>
            </div>
        </div>
        <marquee v-if="data.marqueeNews" class="v-top">{{ data.marqueeNews }}</marquee>
    </Card>
</template>

<script>
import { computed, defineAsyncComponent, defineComponent, reactive, ref, unref, watch } from "vue";
import { Card, Breadcrumb, Button, Row, Col } from "ant-design-vue";
import { useRoute } from "vue-router";
import { state as stateAppLayout, bodyStyle, createRoutedMap, setAppPageHeader } from "./app-layout.logic";
import router from "../../../router";
import lodash from "lodash";
import { callGetMarqueenNews } from "../../../views/app/master-mgt/marquee-news/marquee-news.logic";

export default defineComponent({
    components: {
        Card,
        Breadcrumb,
        BreadcrumbItem: Breadcrumb.Item,
        Button,
        Row,
        Col,
        CIcon: defineAsyncComponent(() => import("../../icon/CIcon"))
    },
    setup() {
        const data = reactive({ history: [unref(router.currentRoute)], noPush: false, marqueeNews: null });
        const route = useRoute();
        const routes = ref([]);
        setInterval(() => (routes.value = createRoutedMap(route.matched, stateAppLayout.menuSides)), 250);
        router.afterEach((to, from) => {
            if (to?.path !== from?.path) {
                setAppPageHeader({ slots: { top: null, default: null }, canBack: true });
            }
        });
        watch(
            () => route.fullPath,
            () => {
                const route = unref(router.currentRoute);
                lodash.remove(data.history, d => {
                    if (d.matched.length > 2 && d.matched.length === route.matched.length) {
                        if (d.matched[d.matched.length - 2].path !== d.matched[d.matched.length - 1].path) {
                            return d.matched[d.matched.length - 2].path === route.matched[route.matched.length - 2].path;
                        }
                    }
                    return false;
                });
                if (data.noPush) {
                    data.noPush = false;
                    return;
                }
                data.history.push(route);
            },
            { flush: "post" }
        );
        const onClickBack = () => {
            if (data.history.length > 1) {
                const lastIndex = data.history.length - 2;
                const back = lodash.remove(data.history, (d, index) => index >= lastIndex)[0];
                router.push(back);
            } else {
                const back = routes.value[routes.value.length - 2];
                data.noPush = true;
                router.push({ path: back.url });
            }
        };
        const canBackComputed = computed(() => {
            if (!stateAppLayout.appPageHeader.canBack) {
                return false;
            }
            return data.history.length > 1 || (stateAppLayout.isLayout && routes.value?.length > 1);
        });
        callGetMarqueenNews().then(res => (data.marqueeNews = res));
        return { stateAppLayout, data, bodyStyle, routes, onClickBack, canBackComputed };
    }
});
</script>

<style scoped>
.app-page-header-card {
    border-left: 0px;
    border-right: 0px;
}
</style>
